import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  redirectUnauthorizedTo,
  redirectLoggedInTo,
  canActivate,
} from '@angular/fire/compat/auth-guard';
import { AdminGuard } from './core/guards/admin.guard';
import { SentToInsideSalesListComponent } from './features/inside-sales/components/sent-to-inside-sales-list/sent-to-inside-sales-list.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['/auth']);
const redirectLoggedInToApp = () => redirectLoggedInTo(['/dashboard']);

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
    ...canActivate(redirectLoggedInToApp),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'generate-lead',
    loadChildren: () =>
      import('./features/leads/lead.module').then((m) => m.LeadModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'customers/:customerId',
    loadChildren: () =>
      import('./features/customer/customer.module').then(
        (m) => m.CustomerModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./features/search/search.module').then((m) => m.SearchModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'appointment',
    loadChildren: () =>
      import('./features/appointment/appointment.module').then(
        (m) => m.AppointmentModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'leads',
    loadChildren: () =>
      import('./features/leads/lead.module').then((m) => m.LeadModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'calendar',
    loadChildren: () =>
      import('./features/calendar/calendars.module').then(
        (m) => m.CalendarsModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  // sales-visit route is not used
  {
    path: 'sales-visit/:id',
    loadChildren: () =>
      import('./features/sales-visit/sales-visit.module').then(
        (m) => m.SalesVisitModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'counts',
    loadChildren: () =>
      import('./features/counts/counts.module').then((m) => m.CountsModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'service-call',
    loadChildren: () =>
      import('./features/service-call/service-call.module').then(
        (m) => m.ServiceCallModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./features/reports/reports.module').then((m) => m.ReportsModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'followUps',
    loadChildren: () =>
      import('./features/follow-ups/follow-ups.module').then(
        (m) => m.FollowUpsModule
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'sentToInsideSales',
    component: SentToInsideSalesListComponent,
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: 'drawing',
    loadChildren: () =>
      import('./features/drawing/drawing.module').then((m) => m.DrawingModule),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
